import { render, staticRenderFns } from "./EditWhatsAppAlert.vue?vue&type=template&id=52ae85b6"
import script from "./EditWhatsAppAlert.vue?vue&type=script&lang=js"
export * from "./EditWhatsAppAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports